import {
  getShellBasePath,
  hasPathPrefix,
  joinPath,
  parsesAsPathSuffix,
} from './path';

export {
  getShellBasePath,
  hasPathPrefix,
  joinPath,
  normalizeBasePath,
  parsesAsPathSuffix,
  registerShellBasePath,
} from './path';

interface Config {
  ENABLE_DEBUG_FEATURES: boolean;
  ANALYTICS_DISABLED: boolean;
  ONPREM: boolean;
  PREFIX: string;
  WANDB_BASE_URL: string;
  ENV_IS_CI: boolean;
  urlPrefixed(path: string): string;
  backendWeaveExecutionUrl(shadow?: boolean): string;
  backendWeaveViewerUrl(): string;
  backendWeaveOpsUrl(): string;
}

const WEAVE_BACKEND_HOST = '/__weave';

const backendWeaveExecutionUrl = (shadow: boolean = false) => {
  if (shadow) {
    return WEAVE_BACKEND_HOST + '/shadow_execute';
  }
  return WEAVE_BACKEND_HOST + '/execute';
};

const backendWeaveOpsUrl = () => {
  return WEAVE_BACKEND_HOST + '/ops';
};

const backendWeaveViewerUrl = () => {
  return WEAVE_BACKEND_HOST + '/wb_viewer';
};

export const coreAppUrl = (path: string = '') => {
  const origin = window.CONFIG?.BACKEND_HOST
    ? window.CONFIG!.BACKEND_HOST.replace('api.', '')
    : 'https://wandb.ai';
  return origin + path;
};

export const urlPrefixed = (path: string, host: boolean = false) => {
  let url = new URL(window.location.origin);
  try {
    const origin = url.href.replace(/\/$/, '');
    if (!parsesAsPathSuffix(origin, path)) {
      return path;
    }
    const basePath = getShellBasePath();
    const prefixedPath =
      basePath && !hasPathPrefix(path, basePath) && joinPath(basePath, path);
    url = new URL(origin + (prefixedPath || path));
  } catch {
    // path isn't a well-formed URL suffix (e.g. arbitrary markdown link
    // text from agent output); return it unprefixed rather than throw.
    return path;
  }
  if (!host) {
    return url.pathname + url.search;
  }
  return url.href;
};

const DEFAULT_CONFIG: Config = {
  urlPrefixed,
  backendWeaveExecutionUrl,
  backendWeaveOpsUrl,
  backendWeaveViewerUrl,
  PREFIX: '',
  ENABLE_DEBUG_FEATURES: false,
  ONPREM: false,
  ANALYTICS_DISABLED: window.CONFIG?.ANALYTICS_DISABLED ?? false,
  WANDB_BASE_URL: window.CONFIG?.BACKEND_HOST ?? 'https://api.wandb.ai',
  ENV_IS_CI: false,
} as const;

let config = {...DEFAULT_CONFIG};

export const setConfig = (newConfig: Partial<Config>) => {
  config = {...config, ...newConfig};
};

export default function getConfig() {
  return config;
}
